import React from 'react';
import styled from '@emotion/styled';

type FrameProps = {
    cols: number;
}

const Frame = styled.div<FrameProps>(props => ({
    boxSizing: 'border-box',
    padding: '4px',
    display: 'grid',
    gridTemplateColumns: `repeat(${props.cols}, 1fr)`,
    gridTemplateRows: 'min-content',
    gap: '4px',
    backgroundColor: '#E9EEF4',
    width: '100%',
    minHeight: '100%',
}));

export type TilingProps = React.PropsWithChildren<{
    cols?: number;
}>;

export const Tiling = (props: TilingProps) => {
    return (
        <Frame cols={props.cols || 2}>
            {props.children}
        </Frame>
    );
};
